module.exports = __webpack_public_path__ + "assets/img/tp.b3b416e4.jpg";